module.exports = {
    ALLOCATIONS: {
        UNALLOCATED: '',
        CONTROL: '1',
        TEST_B: '2',
        TEST_C: '3'
    },
    EXPERIMENTS: {
        CAT_LISTING_CATEGORY_PAGE_ORDER_SIDEMENU: 2397,
        CAT_LISTINGS_GUIDED_SEARCH_NAV_TEST: 2451,
        CAT_LISTINGS_ASP_RECOMMENDATION_PACKAGE: 2766,
        CAT_LISTINGS_SEARCH_SERVICE_TILES: 3014,
        CAT_LISTINGS_NSC_ICONS_MOBILE_WEB: 2893,
        CAT_LISTINGS_GIG_CARD_SERVICES: 2939,
        CAT_LISTINGS_GIG_SUBSCRIPTION_BADGE: 2966,
        CAT_LISTINGS_WEBSITE_MATCH_BANNER: 3036,
        LIONS_PROMOTE_MT_CTA: 2854,
        LIONS_SAME_LANGUAGE_SELLER_TOGGLE: 2870,
        LIONS_STICKY_MT: 3015,
        CAT_LISTINGS_NEW_VERTICAL_PAGE_TEST: 3043,
        CAT_LISTINGS_SERVICE_FILTERS_15_6: 3049
    },
    ROLLOUTS: {
        CAT_SC_NAVIGATION_TILES: 'cat_sc_navigation_tiles',
        CAT_SEARCH_SERVICE_TILES: 'cat_search_service_tiles_may',
        CAT_NSC_ICONS_MOBILE_WEB: 'cat_nsc_icons_mobile_web',
        CAT_GIG_CARD_SERVICES: 'cat_gig_card_services',
        CAT_USE_CMS_KIMERA_URL: 'cat_use_cms_kimera_url',
        CAT_GIG_SUBSCRIPTION_BADGE: 'cat_gig_subscription_badge',
        CAT_WEBSITE_MATCH_BANNER: 'cat_website_match_banner',
        CAT_VERTICAL_PAGE_TEST: 'cat_new_vertical_page',
        CAT_LISTINGS_SERVICE_FILTERS_15_6: 'cat_service_filters_june',
        LIONS_SAME_LANGUAGE_SELLER_TOGGLE: 'lions_same_language_seller_toggle',
        LIONS_STICKY_MT: 'lions_sticky_mt'
    },
    DEFAULT_NUM_OF_GROUPS: 2
};
